import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import ElementPlus from "element-plus";
import App from "./App";
import router from "./router";
import lang from "@/lang";
import store from "@/store";
import PrimeVue from "primevue/config";
import locale from "element-plus/lib/locale/lang/de";
import "dayjs/locale/de";

const app = createApp(App);

const messages = lang;

const i18n = createI18n({
  locale: store.state.language,
  fallbackLocale: "en",
  messages
});

app.use(i18n);
app.use(router);
app.use(PrimeVue);
app.use(ElementPlus, { locale });

app.mount("#app");
